/**
 * @generated SignedSource<<ab294c9d79757d2b19f4d3baad48680f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PriceDisplayBot_item$data = {
  readonly skus: ReadonlyArray<{
    readonly displayPriceAU: ReadonlyArray<{
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
      readonly isVatIncluded: boolean | null;
    } | null> | null;
    readonly displayPriceDefault: ReadonlyArray<{
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
      readonly isVatIncluded: boolean | null;
    } | null> | null;
    readonly displayPriceEU: ReadonlyArray<{
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
      readonly isVatIncluded: boolean | null;
    } | null> | null;
    readonly displayPriceGB: ReadonlyArray<{
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
      readonly isVatIncluded: boolean | null;
    } | null> | null;
    readonly serviceId: string | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"PriceDisplay_item">;
  readonly " $fragmentType": "PriceDisplayBot_item";
};
export type PriceDisplayBot_item$key = {
  readonly " $data"?: PriceDisplayBot_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PriceDisplayBot_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isVatIncluded",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PriceDisplayBot_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": "displayPriceDefault",
          "args": [
            {
              "kind": "Literal",
              "name": "priceBookName",
              "value": "DEFAULT"
            }
          ],
          "concreteType": "ItemDisplayPriceType",
          "kind": "LinkedField",
          "name": "displayPrice",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": "displayPrice(priceBookName:\"DEFAULT\")"
        },
        {
          "alias": "displayPriceAU",
          "args": [
            {
              "kind": "Literal",
              "name": "priceBookName",
              "value": "AU"
            }
          ],
          "concreteType": "ItemDisplayPriceType",
          "kind": "LinkedField",
          "name": "displayPrice",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": "displayPrice(priceBookName:\"AU\")"
        },
        {
          "alias": "displayPriceEU",
          "args": [
            {
              "kind": "Literal",
              "name": "priceBookName",
              "value": "EU"
            }
          ],
          "concreteType": "ItemDisplayPriceType",
          "kind": "LinkedField",
          "name": "displayPrice",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": "displayPrice(priceBookName:\"EU\")"
        },
        {
          "alias": "displayPriceGB",
          "args": [
            {
              "kind": "Literal",
              "name": "priceBookName",
              "value": "GB"
            }
          ],
          "concreteType": "ItemDisplayPriceType",
          "kind": "LinkedField",
          "name": "displayPrice",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": "displayPrice(priceBookName:\"GB\")"
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "catchNonFatalErrors",
          "value": false
        },
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "a621a19ed4f36f64b957b7cc813d14c4";

export default node;
